import type React from 'react'
import { useGetVeliActivationFunnelQuery } from '../../../../../../redux/services/coreApi'
import VeliClientsTable, { type VeliClientRow } from './VeliClientsTable'

// The top-level "Clients" tab: every imported Veli client across all books, flattened into one sortable
// table with a wealth-manager column ("Direct clients" for the no-WM group). The per-WM book and its
// remind action live on the wealth-manager sub-page; this is the read-only roster.
const VeliClientsTab: React.FC = () => {
  const { data, isLoading } = useGetVeliActivationFunnelQuery()

  const rows: VeliClientRow[] =
    data?.wealthManagers.flatMap(book =>
      book.clients.map(client => ({
        ...client,
        id: client.veliUserId,
        wealthManagerName: book.wealthManagerName ?? 'Direct clients',
      }))
    ) ?? []

  return <VeliClientsTable clients={rows} isLoading={isLoading} />
}

export default VeliClientsTab
